export default __webpack_public_path__ + "static/media/image-real-deal.f3117a64.jpg";